import { Fragment } from "react";
import { useNavLinks } from "shared/hooks/useNavLinks";
import { NavbarItem } from "../NavbarItem/NavbarItem";

const NavbarItems = () => {
  const { navbarLinks } = useNavLinks();

  return navbarLinks.map(({ link, href, label, icon = null, render }, idx) => {
    if (render) {
      return <Fragment key={idx}>{render("navbar")}</Fragment>;
    }

    if (href) {
      return (
        <a key={href} href={href} target="_blank" className="nav-item">
          {icon}
          {label}
        </a>
      );
    }

    return <NavbarItem key={link} link={link} label={label} icon={icon} />;
  });
};

export default NavbarItems;
